import en from './locales/en.json';
import de from './locales/de.json';

export const settingsLocales = {
  en: { settings: en },
  de: { settings: de },
};

export { default as SettingsPage } from './SettingsPage.vue';
export * from './settings.routes';
export * from './store';
export * from './settings-users.service';
